import React from 'react';
import { useBreakpointHelpers } from '@sweetgreen/garnish';

import { LoadingResults as LoadingResultsDesktop } from './LoadingResults.desktop';
import { LoadingResults as LoadingResultsMobile } from './LoadingResults.mobile';

export const LoadingResults = () => {
  const { currentBreakpoint } = useBreakpointHelpers();

  return currentBreakpoint.isMobile ? (
    <LoadingResultsMobile />
  ) : (
    <LoadingResultsDesktop />
  );
};
